import { render, staticRenderFns } from "./VuesticWizard.vue?vue&type=template&id=4fbf94ae&scoped=true"
import script from "./VuesticWizard.vue?vue&type=script&lang=js"
export * from "./VuesticWizard.vue?vue&type=script&lang=js"
import style0 from "./VuesticWizard.vue?vue&type=style&index=0&id=4fbf94ae&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbf94ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fbf94ae')) {
      api.createRecord('4fbf94ae', component.options)
    } else {
      api.reload('4fbf94ae', component.options)
    }
    module.hot.accept("./VuesticWizard.vue?vue&type=template&id=4fbf94ae&scoped=true", function () {
      api.rerender('4fbf94ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vuestic-theme/vuestic-components/vuestic-wizard-kyc/VuesticWizard.vue"
export default component.exports